import axios from 'axios';
import { url } from '../../../../../../env';

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  Accept: 'application/json',
});

const multipartHeaders = () => ({
  ...authHeaders(),
  'Content-Type': 'multipart/form-data',
});

export const platesApi = {
  show: (qpId) =>
    axios.get(`${url}/quote-process/${qpId}/plates`, { headers: authHeaders() }),

  template: (qpId, params = {}) =>
    axios.get(`${url}/quote-process/${qpId}/plates/template`, {
      headers: authHeaders(),
      params,
    }),

  defaultAttachments: (qpId) =>
    axios.get(`${url}/quote-process/${qpId}/plates/default-attachments`, {
      headers: authHeaders(),
    }),

  sendEmail: (qpId, formData) =>
    axios.post(`${url}/quote-process/${qpId}/plates/email`, formData, {
      headers: multipartHeaders(),
    }),

  uploadPDFs: (qpId, formData) =>
    axios.post(`${url}/quote-process/${qpId}/plates/upload`, formData, {
      headers: multipartHeaders(),
    }),

  getExtraction: (documentId) =>
    axios.get(`${url}/asset-documents/${documentId}/extraction`, { headers: authHeaders() }),

  consolidated: (qpId) =>
    axios.get(`${url}/quote-process/${qpId}/plates/consolidated`, { headers: authHeaders() }),

  complete: (qpId, payload) =>
    axios.post(`${url}/quote-process/${qpId}/plates/complete`, payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  reject: (qpId, payload) =>
    axios.post(`${url}/quote-process/${qpId}/plates/reject`, payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  modify: (plateId, formData) =>
    axios.post(`${url}/plates/${plateId}/modify`, formData, {
      headers: multipartHeaders(),
    }),

  cancel: (plateId, formData) =>
    axios.post(`${url}/plates/${plateId}/cancel`, formData, {
      headers: multipartHeaders(),
    }),

  reopen: (plateId, payload) =>
    axios.post(`${url}/plates/${plateId}/reopen`, payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  correct: (plateId, formData) =>
    axios.post(`${url}/plates/${plateId}/correct`, formData, {
      headers: multipartHeaders(),
    }),

  timeline: (plateId) =>
    axios.get(`${url}/plates/${plateId}/timeline`, { headers: authHeaders() }),

  getDocumentUrl: (documentId) =>
    axios.get(`${url}/asset-documents/${documentId}/url`, { headers: authHeaders() }),
};

export default platesApi;
